import { ReactNode } from "react";
import CscSubLogo from "Assets/Img/CscSubLogo";
import CustomModal from "Components/Common/CustomModal/CustomModal";
import Skeleton from "Components/Common/Skeleton/Skeleton";
import "./publicPage.scss";

export type PublicPageStatus = "loading" | "ready" | "error";

interface PublicPageShellProps {
  title: string;
  subtitle?: string;
  status: PublicPageStatus;
  errorTitle?: string;
  errorMessage?: string;
  children: ReactNode;
}

const PublicPageShell = ({
  title,
  subtitle = "Consultant Services New England · Secure link",
  status,
  errorTitle = "Invalid or Expired Link",
  errorMessage = "This link is invalid or expired. Please contact CSC New England for a new link.",
  children,
}: PublicPageShellProps) => {
  return (
    <div className="publicPage">
      <CustomModal
        show={status === "error"}
        isCrossBtn={false}
        isFooterVisible={false}
        backdrop="static"
        keyboard={false}
      >
        <div className="ppBlockIcon">🔒</div>
        <div className="ppBlockTitle">{errorTitle}</div>
        <div className="ppBlockMsg">{errorMessage}</div>
      </CustomModal>

      <div className="ppHeader">
        <div className="ppHeaderLogo">
          <CscSubLogo />
        </div>
        <div className="ppHeaderText">
          <div className="ppHeaderTitle">{title}</div>
          <div className="ppHeaderSub">{subtitle}</div>
        </div>
      </div>

      {status === "loading" ? (
        <div className="ppWrap">
          <div className="ppCard">
            <Skeleton width="45%" height={16} style={{ marginBottom: 16 }} />
            <Skeleton width="100%" height={13} style={{ marginBottom: 8 }} />
            <Skeleton width="90%" height={13} style={{ marginBottom: 8 }} />
            <Skeleton width="70%" height={13} />
          </div>
        </div>
      ) : (
        <div className="ppWrap">{children}</div>
      )}
    </div>
  );
};

export default PublicPageShell;
